export default __webpack_public_path__ + "static/media/tool-item-h5-bg2.1b8c9f75.png";